module.exports = __webpack_public_path__ + "public/media/ic_check_arrow_blue.33fe47f5.svg";